import { ButtonInputWithPopover, SelectMultiple } from "@msys/ui";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { FilterProps } from "../../../commons/filters/index.js";
import {
  QuotePublishingStatusFilter,
  useQuotePublishingStatus,
} from "../usePublishingStatus.js";

export function QuotesPublishingFilterButton(
  props: FilterProps<QuotePublishingStatusFilter[]>
) {
  const { t } = useTranslate(["QuoteFilter"]);
  const { publishingStatusOptions } = useQuotePublishingStatus();

  return (
    <ButtonInputWithPopover
      label={t("Publishing status", { ns: "QuoteFilter" })}
      counter={
        props.value &&
        props.value.length > 0 &&
        props.value.length < publishingStatusOptions.length
          ? props.value.length
          : undefined
      }
      content={<QuotesPublishingFilterForm {...props} />}
      popoverWidth="md"
    />
  );
}

function QuotesPublishingFilterForm({
  value,
  setValue,
}: FilterProps<QuotePublishingStatusFilter[]>) {
  const { publishingStatusOptions } = useQuotePublishingStatus();

  return (
    <Box
      sx={{
        p: 1,
      }}
    >
      <FormControl component="fieldset" variant="standard">
        <FormGroup>
          {publishingStatusOptions.map((option, index) => (
            <FormControlLabel
              control={
                <Checkbox
                  size="medium"
                  checked={value.includes(option.value)}
                  onChange={(_event, checked) => {
                    if (checked) {
                      setValue(Array.from(new Set([...value, option.value])));
                    } else {
                      setValue(value.filter(v => v !== option.value));
                    }
                  }}
                />
              }
              label={<Typography variant="body1">{option.label}</Typography>}
              sx={{ ml: 0, mr: 0 }}
              key={`${option.value}-${index}`}
            />
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  );
}

export function QuotesPublishingSelect({
  value,
  setValue,
  ...props
}: FilterProps<QuotePublishingStatusFilter[]>) {
  const { t } = useTranslate("QuoteFilter");
  const { publishingStatusOptions } = useQuotePublishingStatus();

  return (
    <SelectMultiple
      label={t("Publishing status", { ns: "QuoteFilter" })}
      options={publishingStatusOptions}
      value={Array.isArray(value) ? value : [value]}
      onChange={setValue}
      {...props}
    />
  );
}
